import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { MessageCircle, Send } from "lucide-react";

let tplPromise = null;
export const resetWhatsAppTemplate = () => { tplPromise = null; };
const getTemplates = () => (tplPromise ||= api.get("/settings").then(({ data }) => [
  { title: "Hello", text: data.whatsapp_template || "" }, ...(data.whatsapp_templates || []),
]).catch(() => []));

export const fillTemplate = (tpl, lead, agent) => (tpl || "")
  .replaceAll("{name}", (lead.name || "").split(" ")[0] || "there")
  .replaceAll("{agent}", agent || "OMI Fintech")
  .replaceAll("{product}", String(lead.loan_type || lead.insurance_type || lead.product || "insurance/loan").replaceAll("_", " "));

const waNumber = (m) => { const d = String(m || "").replace(/\D/g, ""); return d.length === 10 ? `91${d}` : d; };

export function WhatsAppButton({ lead, size = "icon", variant = "ghost", className = "h-8 w-8 text-green-600", testId = "lead-action-whatsapp-button" }) {
  const { user } = useAuth();
  const [msg, setMsg] = useState("");
  const [tpls, setTpls] = useState([]);
  const [pick, setPick] = useState(0);
  const choose = (list, i) => { setPick(i); setMsg(fillTemplate(list[i]?.text, lead, user?.name)); };
  const onOpen = (o) => { if (o) getTemplates().then((l) => { setTpls(l); choose(l, 0); }); };
  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <Button size={size} variant={variant} className={className} data-testid={testId} title="WhatsApp"><MessageCircle className="h-4 w-4" /></Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end" onClick={(e) => e.stopPropagation()} data-testid="wa-preview">
        <div className="text-xs font-semibold text-muted-foreground mb-1.5">WhatsApp to {lead.name} · {lead.mobile}</div>
        {tpls.length > 1 && <div className="flex flex-wrap gap-1 mb-2" data-testid="wa-quick-replies">
          {tpls.map((t, i) => <button key={t.title + i} type="button" onClick={() => choose(tpls, i)} data-testid={`wa-quick-reply-${i}`}
            className={`text-xs px-2 py-1 rounded-full border transition-colors ${i === pick ? "bg-green-600 text-white border-green-600" : "hover:bg-green-50"}`}>{t.title}</button>)}
        </div>}
        <Textarea rows={4} value={msg} onChange={(e) => setMsg(e.target.value)} className="text-sm bg-green-50/60" data-testid="wa-preview-text" />
        <Button asChild size="sm" className="w-full mt-2 bg-green-600 hover:bg-green-700" data-testid="wa-send-btn">
          <a href={`https://wa.me/${waNumber(lead.mobile)}?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer"><Send className="h-4 w-4 mr-1" />Open in WhatsApp</a>
        </Button>
      </PopoverContent>
    </Popover>
  );
}
